import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { setMonth, format, getYear, getMonth } from "date-fns";
import LOCALE_MODULE_EN_US from "date-fns/locale/en-US";
import { Box, Flex } from "@chakra-ui/react";
import { Select } from "@pluxee-design-system/core";
/**
 * Generate a years window, centered on the current year by default, or the provided one
 */
export function buildYears(middle, window) {
    const middleYear = getYear(middle === undefined ? new Date() : middle);
    const start = middleYear - window;
    const end = middleYear + window;
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
}
export function buildMonths(locale) {
    const months = new Array(12).fill(0).map((_, index) => ({
        index,
        name: format(setMonth(new Date(0), index), "MMMM", {
            locale,
        }),
    }));
    return months;
}
// for some reasons at the first opening the option is not
// autoscrolled to need to do it manually
function onFocusSelect() {
    setTimeout(() => {
        const selectedElement = document.querySelector(`.pluxee-select__option--is-selected`);
        if (selectedElement) {
            selectedElement.scrollIntoView({
                block: "nearest",
                inline: "nearest",
            });
        }
    });
}
export const Header = ({ date, localeModule = LOCALE_MODULE_EN_US, changeMonth, changeYear, window = 50, }) => {
    const months = buildMonths(localeModule);
    const monthOptions = useMemo(() => months.map((month) => ({
        label: `${month.name}`,
        value: `${month.index}`,
    })), [months]);
    const years = buildYears(date, window);
    const yearOptions = useMemo(() => years.map((year) => ({
        label: `${year}`,
        value: `${year}`,
    })), [years]);
    return (_jsx(Box, Object.assign({ sx: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
        } }, { children: _jsxs(Flex, Object.assign({ alignItems: "space-between", sx: { textTransform: "capitalize" } }, { children: [_jsx(Select, { size: "sm", onFocus: onFocusSelect, value: monthOptions[getMonth(date)], options: monthOptions, onChange: (month) => changeMonth(parseInt((month === null || month === void 0 ? void 0 : month.value) || "", 10)) }), _jsx(Select, { size: "sm", value: yearOptions.find((year) => parseInt(year.value, 10) === getYear(date)), onFocus: onFocusSelect, options: yearOptions, onChange: (year) => changeYear(parseInt((year === null || year === void 0 ? void 0 : year.value) || "", 10)) })] })) })));
};
//# sourceMappingURL=Header.js.map